var map = {
	"./PAP_cat_icon_1-to-1.svg": [
		1485,
		44
	],
	"./PAP_cat_icon_1to1-other.svg": [
		1626,
		45
	],
	"./PAP_cat_icon_blog-theme-design.svg": [
		1627,
		46
	],
	"./PAP_cat_icon_book-cover-design.svg": [
		1628,
		47
	],
	"./PAP_cat_icon_brochure-or-menu-design.svg": [
		1629,
		48
	],
	"./PAP_cat_icon_business-card-design.svg": [
		1630,
		49
	],
	"./PAP_cat_icon_business-tagline.svg": [
		1631,
		50
	],
	"./PAP_cat_icon_design-consultation.svg": [
		1486,
		51
	],
	"./PAP_cat_icon_email-design.svg": [
		1632,
		52
	],
	"./PAP_cat_icon_icon-button-and-widget-design.svg": [
		1633,
		53
	],
	"./PAP_cat_icon_illustration-and-graphic-design.svg": [
		1634,
		54
	],
	"./PAP_cat_icon_infographics-design.svg": [
		1635,
		55
	],
	"./PAP_cat_icon_landing-page-design.svg": [
		1636,
		56
	],
	"./PAP_cat_icon_letterhead-and-stationery-design.svg": [
		1637,
		57
	],
	"./PAP_cat_icon_logo-and-business-card-design.svg": [
		1638,
		58
	],
	"./PAP_cat_icon_logo-and-social-media-assets-design.svg": [
		1639,
		59
	],
	"./PAP_cat_icon_logo-design.svg": [
		1640,
		60
	],
	"./PAP_cat_icon_magazine-cover-design.svg": [
		1641,
		61
	],
	"./PAP_cat_icon_merchandise-design.svg": [
		1642,
		62
	],
	"./PAP_cat_icon_mobile-ui-design.svg": [
		1643,
		63
	],
	"./PAP_cat_icon_naming-a-business-or-product.svg": [
		1644,
		64
	],
	"./PAP_cat_icon_other-clothing-design.svg": [
		1645,
		65
	],
	"./PAP_cat_icon_outdoor-or-signage-design.svg": [
		1646,
		66
	],
	"./PAP_cat_icon_package-graphics.svg": [
		1647,
		67
	],
	"./PAP_cat_icon_packaging-design.svg": [
		1648,
		68
	],
	"./PAP_cat_icon_postcard-or-flyer-design.svg": [
		1649,
		69
	],
	"./PAP_cat_icon_poster-design.svg": [
		1650,
		70
	],
	"./PAP_cat_icon_presentation-design.svg": [
		1651,
		71
	],
	"./PAP_cat_icon_product-design.svg": [
		1652,
		72
	],
	"./PAP_cat_icon_social-media-assets-design.svg": [
		1653,
		73
	],
	"./PAP_cat_icon_t-shirt-design.svg": [
		1654,
		74
	],
	"./PAP_cat_icon_tattoo-design.svg": [
		1655,
		75
	],
	"./PAP_cat_icon_vehicle-wrap-design.svg": [
		1656,
		76
	],
	"./PAP_cat_icon_wall-mural-art-design.svg": [
		1657,
		77
	],
	"./PAP_cat_icon_web-banner-design.svg": [
		1658,
		78
	],
	"./PAP_cat_icon_website-design.svg": [
		1659,
		79
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1500;
module.exports = webpackAsyncContext;